import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material'
import { buttonStyles } from '../../../styles/buttonStyles';

interface DeleteConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    email: string;
    message: string;
}

export default function DeleteConfirmationDialog({
    open,
    onClose,
    onConfirm,
    message
}: DeleteConfirmationDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    width: '90%',
                    maxWidth: '400px',
                    p: 2,
                },
            }}
        >
            <DialogContent>
                <Typography
                    align="center"
                    variant="h6"
                    sx={{
                        fontSize: '1.25rem',
                        fontWeight: 500,
                        mb: 2,
                    }}
                >
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
                <Button
                    onClick={onClose}
                    sx={{
                        ...buttonStyles.cancel,
                        width: '120px',
                    }}
                >
                    NO
                </Button>
                <Button
                    onClick={onConfirm}
                    sx={{
                        ...buttonStyles.gradient,
                        width: '120px',
                    }}
                >
                    YES
                </Button>
            </DialogActions>
        </Dialog>
    )
}

